<template>
  <!-- Preloader -->
  <div class="preloader flex-column justify-content-center align-items-center">
    <img
      class="animation__shake"
      src="../assets/img/logo.svg"
      alt="ERN logo"
      height="60"
      width="250"
    />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
